export function chatTypeLabel(title: string): string {
  if (title.toLowerCase() === 'direct message') return 'Direct messages'
  return `${title} conversations`
}
